import { render, staticRenderFns } from "./DeskAnimation.vue?vue&type=template&id=79e1d122&scoped=true&"
import script from "./DeskAnimation.vue?vue&type=script&lang=js&"
export * from "./DeskAnimation.vue?vue&type=script&lang=js&"
import style0 from "./DeskAnimation.vue?vue&type=style&index=0&id=79e1d122&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e1d122",
  null
  
)

export default component.exports